import { render } from "./OrderSmsPage.vue?vue&type=template&id=040af721"
import script from "./OrderSmsPage.vue?vue&type=script&lang=js"
export * from "./OrderSmsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__